// src/redux/slices/userSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// 🔹 Fetch Business User Profile
export const fetchUserData = createAsyncThunk(
  "businessUserProfile/fetchUserData",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        return rejectWithValue("Token missing");
      }

      const baseUrl =
        process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

      const response = await fetch(`${baseUrl}/business/profile`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch profile");
      }

      const data = await response.json();

      if (!data?.user) {
        return rejectWithValue("User not found in response");
      }

      let user = data.user;

      // ✅ Fix profilePic URL if backend sends relative path
      if (user.profilePic && !user.profilePic.startsWith("http")) {
        user.profilePic = `${baseUrl}/${user.profilePic}`;
      }

      // ✅ Format DOB for input type="date"
      if (user.dob) {
        user.dob = user.dob.split("T")[0];
      }

      return user;
    } catch (error) {
      console.error("❌ Fetch User Error:", error);
      return rejectWithValue(error.message);
    }
  }
);

// 🔹 Slice
const userSlice = createSlice({
  name: "businessUserProfile",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    // ✅ optional reset (useful after logout)
    resetUserProfile: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔄 Loading
      .addCase(fetchUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      // ✅ Success
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })

      // ❌ Error
      .addCase(fetchUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// 🔹 Export
export const { resetUserProfile } = userSlice.actions;
export default userSlice.reducer;